import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { TemplateFlexGridContainer } from '../../../components/Grid';
import { Heading } from '../../../components/Heading';
import { ToggleButton } from '../../../components/ToggleButton';
import { ToggleButtonGroup } from '../../../components/ToggleButtonGroup';
import { Toggles } from '../../../components/ToggleButtonGroup/ToggleButtonGroup';
import { noOp } from '../../../lib/utils';
import { ModificationTypes, StepProps } from '../../../types';
import { useBriefingState } from '../BriefingState';
import { modificationTypeOptions } from './modificationTypes';

export const StepModificationType: FC<StepProps> = ({
  // mandatoryFields,
  onValidate = noOp,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [{ modifyBriefingType }, { setModifyBriefingType }] =
    useBriefingState();

  const [isModificationTypeValid] = useState(true);
  const isStepValid = useMemo(
    () => isModificationTypeValid,
    [isModificationTypeValid],
  );
  useEffect(() => onValidate(isStepValid), [isStepValid, onValidate]);

  const [initialTypeSelection] = useState(modifyBriefingType as Toggles);

  const getTranslatedToggleName = useMemo(
    () =>
      modificationTypeOptions.map((item) => ({
        name: t(`${item.name}`),
        value: item.value,
      })),
    [t],
  );

  const onChangeModificationType = useCallback(
    (toggles: Toggles) =>
      dispatch(setModifyBriefingType(toggles as ModificationTypes)),
    [dispatch, setModifyBriefingType],
  );

  return (
    <TemplateFlexGridContainer.BriefingStep>
      <Heading
        level="h1"
        margin={0}
        text={t('topics:modification-type:heading:general')}
      />
      <TemplateFlexGridContainer.BriefingStepBody>
        <TemplateFlexGridContainer.BriefingStepSection>
          <div>
            <Heading
              level="h3"
              margin={0}
              text={t('topics:modification-type:heading:type')}
            />
            <p className="mt-1 text-gray-600 text-2xs font-regular">
              {t('labels:multiSelectHint')}
            </p>
          </div>
          <div className="w-full">
            <div
              data-test="modify-buttons-container"
              className="flex flex-col space-y-6 md:flex-row md:space-y-0"
            >
              <ToggleButtonGroup
                initialToggles={initialTypeSelection}
                multi={true}
                onChange={onChangeModificationType}
              >
                <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
                  {getTranslatedToggleName.map((typeOption) => (
                    <ToggleButton
                      text={typeOption.name}
                      value={typeOption.value}
                      key={typeOption.value}
                      on={true}
                    />
                  ))}
                </div>
              </ToggleButtonGroup>
            </div>
          </div>
        </TemplateFlexGridContainer.BriefingStepSection>
      </TemplateFlexGridContainer.BriefingStepBody>
    </TemplateFlexGridContainer.BriefingStep>
  );
};
